import React, { useState, useEffect, useContext, useRef } from "react";
// import TemplateHeader from "../components/template/TemplateHeader";
// import TemplateLeftPanel from "../components/template/TemplateLeftPanel";

import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import "../css/TemplateManger.scss";
import "../css/dashboardPage.scss";
import "react-toastify/dist/ReactToastify.css";
import { emitter } from "../utils/editorUtils/editorUtils.js";
import nineDotIcon from "../images/nine-dotIcon.svg";
import gileadIcon from "../images/gileadIcon.svg";
import notifyBell from "../images/notifyBell.svg";
import edetailInactive from "../images/Edetail-Inactive.svg";
import edetailActive from "../images/EdetailManagerActive.svg";
import templateInactive from "../images/Template-Inactive.svg";
import templateActive from "../images/TemplateManagerActive.svg";
import activeManagerTip from "../images/ActiveArrow.svg";
import ExpandIcon from "../images/expand-icon.svg";
import {
  createeDetail,
  getAlleDetail,
  searchForDetails,
  deleteEdetail,
  getBrandDetails,
  getMarketDetails,
  getCampaignDetails,
  cloneTemplateApi,
  PDFPreview,
  lockCardTemplate,
  getExpireDetails,
  openPdfRsdPreview
} from "../services/apis";
import CircularProgressBar from "../utils/CircularProgressBar";
import { removeEdtailData } from "../utils";
import Template from "./Template.js";
import DeleteTemplate from "../components/template/DeleteTemplate";
import CustomModal from "../components/CustomModal";
import ExportTemplate from "../components/ExportTemplate";
import EDetailForm from "./EdetailForm";
import ValueContext from "../utils/contextAPI/contextAPI";
import { template, eDetail } from "../utils/constants";
import { useKeycloak } from "@react-keycloak/web";
import {
  ExportDeckToMail,
  getDeviceDetails,
  getDimensionDetails,
  getDeckTraceabilityMatrix,
} from "../services/apis";
import LockTemplate from "../components/template/LockTemplate";
import DetailsInformationsModal from "../components/DetailsInformationsModal";
import ExpireTemplate from "../components/template/ExpireTemplate";
import SharedResource from "../components/SharedResource/SharedResource";
import SearchManagerComponent from "../components/SearchManager/SearchManagerComponent.js";
import Logout from "../components/Logout/Logout.js";
import LogoutDropdownCard from "../components/Logout/LogoutDropdownCard"
import TourPage from "./TourPage.js";
import { showChildrenPropsToast, showErrorToast, showSuccessToast } from "../components/toastComponent/ToastComponent.js";
import { unifiedPageUrl } from "../services/axiosConfig.js";
import PdfDetailsInformationModal from "../components/ContentModules/ModuleWindow/PdfDetailsInformationModal/PdfDetailsInformationModal.js";

const EDetails = (props) => {
  const appData = useContext(ValueContext);
  const [openCreateNewtemplate, setOpenCreateNewtemplate] = useState(false);
  const [openCloneTemplate, setOpenCloneTemplate] = useState(false);
  const [textFieldValidationError, setTextFieldValidationError] =
    useState(false);
  const [isloading, setIsloading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const location = useLocation();
  const { keycloak } = useKeycloak();
  //new implementation craetedby and byothers
  const [showFetchedResults, setshowFetchedResults] = useState([]);
  const [skipRange, setSkipRange] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [createdbyMe, setCreatedbyMe] = useState("me");
  const [expired, setExpired] = useState(false);
  const [showCount, setShowCount] = useState(" ");
  const [createdByOthers, setCreatedbyOthers] = useState(false);
  const [openExpireModal, setOpenExpireModal] = useState(false);
  const [expireTemplateData, setExpireTemplateData] = useState(null);
  const [templateTypes, setTemplateTypes] = useState();
  const [isOpenSharedModal, setIsOpenSharedModal] = useState(false);
  const [deckIdCurrent, setDeckIdCurrent] = useState();
  const pendingUpdates = useRef({}); // buffer SSE updates for unknown IDs

  //end
  const start = 0;
  const limit = 100;

  let navigate = useNavigate();
  const infinteScrollRef = useRef();
  const [createPresentationFields, setCreatePresentationFields] = useState({
    presentationName: "",
    brand: "",
    market: "",
    dimension: "",
    device: "",
    campaign: "",
    templateName: "",
    type: 2,
  });

  const [eDetailFields, setEDetailFields] = useState({
    searchInput: "",
    brand: "",
    market: "",
    device: "",
    campaign: "",
  });
  const [openDeleteTempModal, setOpenDeleteTempModal] = useState(false);
  const [edetailList, setEdetailList] = useState([]); // This variable should be removed
  const [searchClickEdetail, setSearchClickEdetail] = useState(false);
  // const [searchClicktemplate, setSearchClicktemplate] = useState(false);

  const [showHeading, setShowHeading] = useState({
    tempResheader: "Templates (0)",
    edetailResHeader: "E-details (0)",
  }); // This variable should be removed

  const [isOpenCreateFromTemp, setIsOpenCreateFromTemp] = useState(false);
  const [cloneTempdata, setCloneTempdata] = useState([]);
  const [lastSearch, setLastSearch] = useState({
    searchInput: "",
    brand: "",
    market: "",
    device: "",
    campaign: "",
  });

  // const [categoryType, setCategoryType] = useState(eDetail); // Default: /edetail-manager
  const categoryType = Number(props.categoryType) || 2; // Default edetail
  const [brands, setBrands] = useState([]);
  const [market, setMarket] = useState([]);
  const [campaign, setCampaign] = useState([]);
  const [deleteId, setDeleteId] = useState(undefined);
  const [openExportModal, setOpenExportModal] = useState(false);
  const [totalCount, setTotalCount] = useState();
  const [exportFormats, setExportFormats] = useState("");
  const [marketDataList, setmarketDataList] = useState([]);
  const [cardID, setCardID] = useState(null);
  const [searchresults, setSearchresults] = useState(0);
  const [openLockModal, setOpenLockModal] = useState(false);
  const [lockCardData, setLockCardData] = useState({});
  const [cardDetails, setCardDetails] = useState(null);
  const [openCardDetailsModal, setOpenCardDetailsModal] = useState(false);
  const [templateType, setTemplateType] = useState("");
  const [defaultLink, setDefaultLink] = useState();
  const [sharedToggle, setSharedToggle] = useState(false);
  const [localShared, setLocalShared] = useState(true);
  const [tempValue, setTempValue] = useState(null);
  const [isOpen, setIsOpen] = useState(true);
  const [marketDetails, setMarketDetails] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const cameFrom = location.state?.cameFrom;

  const createdFlagKey = {
    all: 'all',
    others: 'createdByOthers',
    me: 'createdByMe'
  }
  const [value, setValue] = useState("");
  const ratio = [
    { name: "4:3", id: "ratio_4_3" },
    { name: "16:9", id: "ratio_16_9" },
    { name: "59:41", id: "ratio_59_41" }
  ];
  const [fetchingList, setFetchingList] = useState(false);
  const [fetchingListError, setFetchingListError] = useState(false);
  const isToastOpenRef = useRef(false);
  
  const handleTabClick = (selectedTab) => {
    navigate(`/${selectedTab}-manager`);
  };
  
  useEffect(() => {
    getDeviceDetails((response, err, errorCode) => {
      if (err) {
        if (errorCode === 400) {
          showErrorToast(err.response.data.error);
        } else if (errorCode === 401) {
          showListingFetchErrorToast("Your session has expired. Please sign in again.");
        } else {
          // showErrorToast('Clone Template failed');
          showListingFetchErrorToast("Unable to load right now. Please try again.");
        } 
        setIsloading(false);
      } else {
        setIsloading(false);
        let revData = response.data.reverse();
        appData.setDevices(revData);
      }
    });
    getDimensionDetails((response, err, errorCode) => {
      if (err) {
        if (errorCode === 400) {
          showErrorToast(err.response.data.error);
        } else if (errorCode === 401) {
          showListingFetchErrorToast("Your session has expired. Please sign in again.");
        } else {
          // showErrorToast('Clone Template failed');
          showListingFetchErrorToast("Unable to load right now. Please try again.");
        }
        setIsloading(false);
      } else {
        setIsloading(false);
        // setDimensions([{ ...dimensions[0], id: response.data[0]?._id }]);
        appData.setDimensions([
          {
            ...appData.dimensions[0],
            id: response.data[0]?._id,
            value: "1024*768",
          },
        ]);
      }
    });
    //switchToManager(2)

    if (categoryType === 1) {
      handleCreatebutton("template", template);
    } else {
      handleCreatebutton("e-Detail", eDetail);
    }
    
    fetchBrands();
    fetchMarket();
    fetchCampaigns();
    setTokenExpirationCheck();
    
    if (cameFrom === "webaction") {
      handleCreatebutton(categoryType == 1 ? 'template' : 'e-Detail', categoryType)
    }
  }, []);

  const categoryTypeName = categoryType===2 ? "e-Detail" : "Template";
  const createTemplate = categoryType===1;
  const createEdetail = categoryType===2;

  useEffect(()=>{
    const typeNo = Number(props.categoryType) || 2; // Default edetail
    // setCategoryType(typeNo);
    if (typeNo === 1) {
      handleCreatebutton("template", template);
    } else {
      handleCreatebutton("e-Detail", eDetail);
    }
  }, [props.categoryType]);
  
    const showListingFetchErrorToast = (msg) => {
      if (isToastOpenRef.current) return;
      isToastOpenRef.current = true;
      showErrorToast(msg);
      setTimeout(() => {
        isToastOpenRef.current = false;
      }, 3000);
    }

  const openCreateNewPresenationModal = () => {
    setOpenCreateNewtemplate(!openCreateNewtemplate);
  };

  const logoutButton = React.forwardRef(({ children, onClick, expanded }, ref) => {
    return (
      <div
        title="Logout"
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
        className="d-flex portal-container"
      >
        <div className="d-flex align-items-center user-info">
          <h3 className="user-title">{getFirstLetters()}</h3>
          <img src={ExpandIcon} alt="expand-icon" width={12} height={8} className={expanded ? "" : "icon-rotate"} />
        </div>
      </div>
    )
  });

  // const logoutMenu = React.forwardRef(
  //   ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
  //     return (
  //       <div
  //         ref={ref}
  //         style={style}
  //         className={`pt15 pb15 ${className}`}
  //         aria-labelledby={labeledBy}
  //       >
  //         <ul className="list-unstyled appDropdown">
  //           {React.Children.toArray(children).filter(
  //             (child) =>
  //               !value || child.props.children.toLowerCase().startsWith(value)
  //           )}
  //         </ul>
  //       </div>
  //     );
  //   }
  // );

  // const openShardedHandler = () => {
  //   setOpenCreateNewtemplate(false);
  //   setIsOpenSharedModal(true);
  // };

  const openCloneTemplateModal = (cloneTempId) => {
    //changed to showFetchedResults, as we have data in it
    let res = showFetchedResults?.filter(
      (element) => element.type === template && element._id === cloneTempId
    );
    if (res[0]?.device) {
      let id =
        typeof res[0].device === "string" ? res[0].device : res[0]?.device?._id;
      let name = appData.devices.filter((item) => item?._id === id)[0].name;
      res[0].device = { name: name, _id: id };
    }
    setCloneTempdata(res);
    setOpenCloneTemplate(!openCloneTemplate);
  };
  const closeCloneTemplateModal = () => {
    setOpenCloneTemplate(false);
  };
  const handleDeletetemplate = (id) => {
    setOpenDeleteTempModal(true);
    setDeleteId(id);
  };
  const closeDeletetemplate = () => {
    setOpenDeleteTempModal(false);
  };
  const clicKRsdPreview = (id) => {
    setCardID(id._id);
    setIsloading(true);
    openPdfRsdPreview(id?._id, (response, err, errorCode) => {
      if (err) {
        setIsloading(false);
        showErrorToast(err.response.data.error);
      } else {
        setIsloading(false);
        window.open(response.data.response.rsdPreviewLink, '_blank', 'noopener,noreferrer');
      }
    });
  };
  const handleExportModal = (id) => {
    setCardID(id._id);
    setIsloading(true);
    PDFPreview(id?._id, (response, err, errorCode) => {
      const errorData = err?.response?.data?.err;

      if (typeof errorData === 'string' && errorData.startsWith("Slide Named")) {
        setIsloading(false);
        showErrorToast(errorData);
      } else if (errorData?.message) {
        setIsloading(false);
        showErrorToast("Export failed. Please try again.");
      } else if (errorData) {
        console.log(err);
        setIsloading(false);
        showErrorToast('Export failed. Please try again.');
      } else {
        setIsloading(false);
        // setpdfURL(response.data);
        showSuccessToast('Your link will be emailed shortly');
      }
    });

    // setOpenExportModal(true);

  };
  const closeExportModal = () => {
    setOpenExportModal(false);
    setExportFormats("");
  };
  const lockTemplate = (cardData) => {
    setOpenLockModal(true);
    setLockCardData(cardData);
  };

  const cardDetailsHandler = (id, cardDetails) => {
    const slideId = cardDetails?.slides[0]?.slideid?._id;
    const isPdfToHtml = cardDetails?.tags.includes('PDF_TO_HTML');
    const deckId = cardDetails?._id;
    const linkId = isPdfToHtml ? deckId : slideId;
    setDefaultLink(linkId);
    setTemplateType(cardDetails.type === 1 ? "template" : "edetail");
    getDeckTraceabilityMatrix(id, (response, err, errorCode) => {
      if (err) {
        console.log(err);
      } else {
        setCardDetails(response.data);
        setOpenCardDetailsModal(true);
      }
    });
  };

  const closeCardDetailsModal = () => {
    setOpenCardDetailsModal(false);
  };

  const closeLockModal = () => {
    setOpenLockModal(false);
    setLockCardData({});
  };

  const proceedLock = (e) => {
    const data = {
      id: lockCardData?._id,
      lock: lockCardData?.locked ? false : true,
    };
    lockCardTemplate(data, (response, err, errorCode) => {
      if (err) {
        showErrorToast('Locked failed. Pl try again');
      } else {
        let data = response.data.response;
        let copyShowFetchedResults = showFetchedResults.slice();
        let index = copyShowFetchedResults.findIndex(
          (list) => list._id === data._id
        );
        copyShowFetchedResults[index].locked = data?.locked;
        setOpenLockModal(false);
        setshowFetchedResults(copyShowFetchedResults);
      }
    });
  };

  const expireTemplateHandler = (cardDetail, templateName) => {
    if (templateName === 1) {
      getDeckTraceabilityMatrix(cardDetail._id, (response, err, errorCode) => {
        if (err) {
          console.log(err);
        } else {
          setTemplateTypes(templateName);
          setOpenExpireModal(true);
          setExpireTemplateData(response.data);
        }
      });
    } else {
      setTemplateTypes(templateName);
      setOpenExpireModal(true);
      setExpireTemplateData(cardDetail);
    }
  };

  const closeExpireTemplateModal = () => {
    setOpenExpireModal(false);
    setExpireTemplateData(null);
  };

  const expireProceedHandler = () => {
    const expiredData = {
      deckId: expireTemplateData?._id,
      expired: expireTemplateData?.expired ? false : true,
    };
    setIsloading(true);
    getExpireDetails(expiredData, (response, err, errorCode) => {
      if (err) {
        showErrorToast('Expiry Failed_Please try again');
      } else {
        if (response) {
          setIsloading(false);
          showChildrenPropsToast(<div className="toast-text-message expiremsg-contaner">
            <div className="expire-message">Expired successfully</div>
            <div className="d-flex align-items-center">
              <span className="expire-template-id">
                {templateTypes === 1 ? "Template ID" : "e-Detail ID"}
              </span>
              <span className="expire-template-name">
                {response?.data?.response._id}
              </span>
            </div>
            <div className="d-flex align-items-center expire-dams">
              <span className="expire-template-id">DAMS ID</span>
              <span className="expire-template-name">
                {response?.data?.response?.veevaMetadata.length > 0
                  ? response?.data?.response?.veevaMetadata[0]?.pdfNo
                  : "-"}
              </span>
            </div>
          </div>);
          // let data = response.data.response;
          let copyShowFetchedResults = showFetchedResults.slice();
          let index = copyShowFetchedResults.findIndex(
            (list) => list?._id === expiredData?.deckId
          );
          copyShowFetchedResults.splice(index, 1);
          setshowFetchedResults(copyShowFetchedResults);
          //handled count show while expiration
          setShowCount({ ...showCount, createdByMe: showCount.createdByMe - 1, all: showCount.all - 1 });
          setOpenExpireModal(false);
        }
      }
    });
  };

  const fetchBrands = () => {
    getBrandDetails((response, err, errCode) => {
      if (err) {
      } else {
        //parse and save
        const data = response.data;
        if (data) {
          setBrands(data);
        }
      }
    });
  };
  const fetchMarket = () => {
    getMarketDetails((response, err, errCode) => {
      if (err) {
      } else {
        //parse and save
        // const data = response.data;
        if (response) {
          const countriesList = response.data;

          let marketData = [];
          countriesList.forEach((item) => marketData.push(item.name));
          setmarketDataList(response.data);
          setMarket(marketData);
          setMarketDetails(countriesList);
        }
      }
    });
  };
  const fetchCampaigns = () => {
    getCampaignDetails((response, err, errCode) => {
      if (err) {
      } else {
        //parse and save
        const data = response.data;
        if (data) {
          setCampaign(data);
        }
      }
    });
  };
  const removecategoryType = () => {
    window.localStorage.removeItem("categoryType");
    // window.localStorage.removeItem("cardData");
    // window.localStorage.removeItem("cardID");
  };

  const createNewEdetail = (payload, presentationMetadata) => {
    const createPresentationFields = { ...presentationMetadata };
    let nameType = payload === template ? "Template" : "Presentation";

    setTempValue(payload);

    if (
      createPresentationFields.presentationName.trim() !== "" ||
      createPresentationFields.templateName.trim() !== ""
    ) {
      if (
        /^\s/.test(
          createPresentationFields.presentationName ||
          createPresentationFields.templateName
        ) !== true
      ) {
        if (
          createPresentationFields.templateName.trim().length > 2 ||
          createPresentationFields.presentationName.trim().length > 2
        ) {
          if (createPresentationFields.templateName.length <= 100) {
            const edetailPayload = {
              name:
                payload === template
                  ? createPresentationFields?.templateName
                  : createPresentationFields?.presentationName,
              brand: brands[brands.map(list => list.name).indexOf(createPresentationFields?.brand)]
                ._id || createPresentationFields?.brand,
              market:
                marketDataList[market.indexOf(createPresentationFields?.market)]
                  ._id,
              // dimension: appData.dimensions[0]?.id, // createPresentationFields?.dimension,
              // device: createPresentationFields?.device?._id,
              dimension: null, // createPresentationFields?.dimension,
              device: null,
              //campaign: createPresentationFields?.campaign,
              type: payload,
              desc: "",
              slides: [],
              thumbnail: "",
              tags: [],
              created: {
                userid: "",
                username: "",
                name: "",
              },
              default_aspect_ratio: ratio[ratio.map(idList => idList.name).indexOf(createPresentationFields.default_aspect_ratio)]?.id || null
              ,
            };
            setIsloading(true);

            createeDetail(edetailPayload, (response, err, errorCode) => {
              if (err) {
                //showError(errorCode);
                const errNotify =
                  errorCode === 400
                    ? // ? err.response.data.error
                    "Same name already exists. Pl rename"
                    : payload === 1
                      ? "Template creation failed. Pl try again"
                      : "Edetail creation failed. Pl try again";
                //  errNotify();
                showErrorToast(errNotify);
                setIsloading(false);
              } else {
                setIsloading(false);
                const successToast =
                  payload === 1
                    ? "Template creation successful"
                    : "e-Detail creation successful";
                // if (!localShared){
                showSuccessToast(successToast);
                // }
                const returnedResponse = response?.data?.response;
                const pageId = returnedResponse.slides[0].slideid._id;

                setOpenCreateNewtemplate(false);
                //  history("/Editor", { state: { data: response.data } });

                // removeEdtailData();
                //Need to check again
                const localData = {
                  edetailId: returnedResponse._id,
                  slides: [],
                };
                localData.slides.push({
                  slideid: returnedResponse.slides[0].slideid._id,
                });
                appData.setDeckId(returnedResponse);
                removecategoryType();

                let cattype = payload === template ? 1 : 2;
                window.localStorage.setItem("categoryType", cattype);
                appData.setDeckId(returnedResponse);
                if (localShared) {
                  setDeckIdCurrent(returnedResponse);
                  setIsOpenSharedModal(true);
                } else {
                  navigateToEditor(pageId, returnedResponse);
                }
              }
            });
          } else {
            setOpenCreateNewtemplate(true);
            showErrorToast(`${nameType}  name exceeded the maximum length`);
          }
        } else {
          setTextFieldValidationError(true);
        }
      } else {
        showErrorToast(`${nameType} name can't start with spaces`);
      }
    } else {
      showErrorToast(`Please provide ${nameType} name`);
    }
  };
  //New Template creation and Editior Redirection 2498
  const navigateToEditor = (pageId, data) => {
    navigate(`/editor/${pageId}`, { state: { data: data }, replace: true });
  };

  const setTokenExpirationCheck = () => {
    // Set interval to check token expiration every 1 minute
    setInterval(() => {
      if (keycloak.token) {
        const expired = keycloak.tokenParsed.exp * 1000 < Date.now();
        if (expired) {
          console.log("Token expired, logging out...");
          keycloak.logout();
        }
      }
    }, 1200000); // Check every 60 seconds
  };

  const applyPendingUpdates = (prev) => {
    const updated = [...prev];
    const appliedIds = [];

    updated.forEach((item, index) => {
      const pending = pendingUpdates.current[item._id];
      if (!pending) return;

      let updatedItem = item;
      let hasChanged = false;

      // Handle metadata_update
      if (pending.metadata_update) {
        const assetIndex = (item.veevaMetadata ?? []).findIndex(a => a.assetType === 1);
        if (assetIndex !== -1) {
          const asset = item.veevaMetadata[assetIndex];
          if (asset.docStatus !== pending.metadata_update.docStatus) {
            // clone item and metadata array only if changed
            updatedItem = { ...updatedItem };
            const newMetadata = [...(item.veevaMetadata ?? [])];
            newMetadata[assetIndex] = { ...asset, docStatus: pending.metadata_update.docStatus };
            updatedItem.veevaMetadata = newMetadata;
            hasChanged = true;
          }
        }
      }

      // Handle export_status_update
      if (pending.export_status_update) {
        const data = pending.export_status_update;
        const userId = data.userId || item.created?.userid;
        const exportJobs = item.exportJob ?? [];
        const jobIndex = exportJobs.findIndex(j => j.userId === userId);

        if (jobIndex !== -1) {
          const job = exportJobs[jobIndex];
          if (job.status !== data.status || job.fileUrl !== data.fileUrl) {
            updatedItem = updatedItem === item ? { ...updatedItem } : updatedItem;
            const newJobs = [...exportJobs];
            newJobs[jobIndex] = { ...job, status: data.status, fileUrl: data.fileUrl };
            updatedItem.exportJob = newJobs;
            hasChanged = true;
          }
        } else {
          updatedItem = updatedItem === item ? { ...updatedItem } : updatedItem;
          updatedItem.exportJob = [...exportJobs, data];
          hasChanged = true;
        }
      }

      if (hasChanged) {
        updated[index] = updatedItem;
        appliedIds.push(item._id);
      }
    });

    // Remove applied pending updates
    appliedIds.forEach(id => delete pendingUpdates.current[id]);

    return updated;
  };

  const getEdetailList = (type, createdByFlag, action) => {
    // removeEdtailData();
    appData.setDeckId(null);
    setIsloading(true);
    setFetchingList(true);
    setEDetailFields({
      searchInput: "",
      brand: "",
      market: "",
      device: "",
      campaign: "",
    });

    setSearchClickEdetail(false);

    /* fetchMore(true, 0, false, type); //yasmin Suggested
    setCreatedbyOthers(false) */
    // setHasMore(true);

    getAlleDetail({
      categoryType,
      type,
      start,
      limit,
      created: createdByFlag,
      expired: false, //type == 2 ? false : expired,// Fix for Bug 766
      callBack: async (response, err, errorCode) => {
        // getAlleDetail({
        //   type,
        //   start,
        //   limit,
        //   callBack: async (response, err, errorCode) => {
        if (err) {
          setFetchingList(false);
          setFetchingListError(true);
          // errNotify();
          if (errorCode === 401) {
            showListingFetchErrorToast("Your session has expired. Please sign in again.");
            keycloak.logout();
          }
          // showErrorToast('Failed to fetch');
          showListingFetchErrorToast("Unable to load right now. Please try again.");
          setIsloading(false);
        } else {
          let result = await response;
          // console.log(
          //   "callig on constructor level",
          //   response.data.response?.decks
          // );
          setshowFetchedResults(applyPendingUpdates(response?.data?.response?.decks));
          setShowCount(response.data?.response?.totalCount);
          setCreatedbyMe(createdByFlag);
          setCreatedbyOthers(false);
          setEdetailList(response.data?.response?.decks);
          setTotalCount(response.data?.response?.totalCount);
          // setTemplateList(res)
          setIsloading(false);
          setFetchingList(false);
          setFetchingListError(false);
          setHasMore(response.data?.response?.totalCount[createdFlagKey[createdByFlag]] > 100 ? true : false);
          if (response.data.totalCount > 100) {
            if (action === "reset") {
              //to handle reset conflicts
              setSkipRange(limit);
            } else {
              setSkipRange(limit + skipRange);
            }
          }
        }
        //},
      },
    });
  };

  const deleteEdetailCard = (edetailId) => {
    deleteEdetail(edetailId, (response, err, errorCode) => {
      if (err) {
        showErrorToast(`${categoryTypeName} deletion failed`);
        setIsloading(false);
        setOpenDeleteTempModal(false);
      } else {
        // setIsloading(false);
        showSuccessToast('Deletion successful');
        // let categoryType = categoryType;
        // getEdetailList(categoryType);
        setOpenDeleteTempModal(false);
        setSearchresults(searchresults - 1);
        /* edetailList.splice(
          edetailList.findIndex((edetail) => edetail._id === edetailId),
          1
        ); */
        showFetchedResults.splice(
          showFetchedResults.findIndex((edetail) => edetail._id === edetailId),
          1
        );
        setEdetailList(edetailList);
        setshowFetchedResults(showFetchedResults);
        setShowCount(showCount - 1);
        setTotalCount(totalCount - 1);
      }
    });
  };

  const getSearchResults = (data) => {
    // console.log(data, 'data777')
    setCreatedbyMe(data?.created)
    if (
      data &&
      (data.brand !== "" ||
        data.campaign !== "" ||
        data.market !== "" ||
        data.mlrStatus !== "" ||
        data.indication !== "" ||
        data.contentType !== "" ||
        (data.searchInput !== "" && data.searchInput.trim() !== "") ||
        (data.device !== "" && data.device !== undefined))
    ) {
      let searchString = "";
      if (data) {
        const searchPayload = {
          brand: data.brand ? data.brand : "",
          market: data.market ? data.market : "",
          mlrStatus: data.mlrStatus ? data.mlrStatus : "",
          indication: data.indication ? data.indication : "",
          contentType: data.contentType ? data.contentType : "",
          campaign: data.campaign ? data.campaign : "",
          searchInput: data.searchInput ? data.searchInput : "",
          type: categoryType,
          device: data?.device ? data?.device : "",
          skip: data.skip,
          limit: data.limit,
          created: data?.created,
          expired: expired,
          // mlrStatus: data.mlrStatus,
        };
        // console.log(searchPayload, 'searchPayload')
        // let val = data.brand ? (searchString = `brand=${data.brand}`) : "";
        // val = data.market
        //   ? (searchString = searchString + `&market=${data.market}`)
        //   : "";
        // val = data.campaign ? searchString + `&campaign=${data.campaign}` : "";
        // val = data.searchInput
        //   ? searchString + `&name=${data.searchInput}`
        //   : "";
        // val = createEdetail
        //   ? searchString + `&type=${eDetail}`
        //   : searchString + `&type=${template}`;
        // val = data.device ? searchString + `&device=${data.device}` : "";

        setIsloading(true);
        setFetchingList(true);

        searchForDetails(searchPayload, (response, err, errorCode) => {
          if (err) {
            setFetchingList(false);
            setFetchingListError(true);
            const type = categoryType;
            if (type === eDetail) {
              showErrorToast('E-Details search failed');
              setshowFetchedResults([]);
              setEdetailList([]);
              setSearchresults(0);
            } else {
              showErrorToast('Template search failed');
              setEdetailList([]);
              setSearchresults(0);
            }
            setIsloading(false);
            if (errorCode === 401) {
              keycloak.logout();
            }
          } else {
            setshowFetchedResults(applyPendingUpdates(response.data?.response?.decks));
            setShowCount(response.data?.response?.totalCount);
            setEdetailList(response.data?.response?.decks);
            setTotalCount(response.data?.response?.totalCount);
            setIsloading(false);
            setFetchingList(false);
            setFetchingListError(false);
            setHasMore(
              response.data?.response?.totalCount[createdFlagKey[searchPayload.created]] > 100 ? true : false
            );
            setSkipRange(100); // Assuming this is first search
            let filterTemplatedata = response.data.response?.decks
              ? response.data?.response?.decks.filter(
                (element) => element.type === template
              )
              : "";
            let filterEdetaildata = response.data
              ? response.data?.response?.decks.filter(
                (element) => element.type === eDetail
              )
              : "";
            let searchlength = createEdetail
              ? filterEdetaildata.length
              : filterTemplatedata.length;
            setSearchresults(searchlength);
          }
        });
      } else {
        getEdetailList(categoryType);
      }
    } else {
      showErrorToast('Please provide at least one input');
      setSearchClickEdetail(false);
      //  setSearchClicktemplate(false);
    }
  };

  const sendSearchDataToEdetails = (data, type, action) => {
    // console.log('df', data)
    setSearchClickEdetail(true);
    //This is commented as we have one search function
    // if (categoryType === eDetail) {
    //   setSearchClickEdetail(true);
    //   setSearchClicktemplate(false);
    // } else {
    //   setSearchClickEdetail(true);
    //   //setSearchClicktemplate(true);
    // }
    if (type === "search") {
      if (action === "reset") {
        setSearchClickEdetail(false);
      }
      setshowFetchedResults([]);
      getSearchResults(data);
    } else {
      getEdetailList(categoryType, true, "reset");
    }
  };

  const createFromTemplate = () => {
    setOpenCreateNewtemplate(false);
    setIsOpenCreateFromTemp(true);
  };
  // const showTemplateRes = edetailList
  //   ? edetailList?.filter((element) => element.type === template)
  //   : "";
  // const showResults = edetailList
  //   ? edetailList?.filter((element) => element.type === eDetail)
  //   : "";

  const handleCreatebutton = (typeValue, type) => {
    setExpired(false);
    setshowFetchedResults([]);
    setShowCount(" ");
    // setCategoryType(type);
    //setTemplateType(typeValue);

    setEDetailFields({
      searchInput: "",
      brand: "",
      market: "",
      device: "",
      campaign: "",
    });
    setSearchClickEdetail(false);
    //setSearchClicktemplate(false);

    if ((typeValue === "eDetail") || (typeValue === "e-Detail")) {
      // setCategoryType(eDetail);
      setExpired(false);
    } else {
      // setCategoryType(template);
      setExpired(false);
    }
    setCreatedbyMe("me");
    getEdetailList(type, "me");
  };

  const onProceedHandler = (cardData) => {
    setIsloading(true);
    const filteredMarketList = marketDataList.filter(
      (marketList) => marketList?.name === createPresentationFields?.market
    );
    const templatePayload = {
      name: createPresentationFields?.presentationName,
      brand: createPresentationFields?.brand,
      market: filteredMarketList[0]?._id,
      // dimension: createPresentationFields?.dimension,
      dimension: appData.dimensions[0]?.id,
      device: createPresentationFields?.device?._id,
      campaign: createPresentationFields?.campaign,
      type: 2,
      default_aspect_ratio: createPresentationFields.default_aspect_ratio,
    };

    var res = cardData.map((s) => s);

    cloneTemplateApi(res[0], templatePayload, (response, err, errorCode) => {
      if (err) {
        setIsloading(false);
        if (errorCode === 400) {
          showErrorToast(err.response.data.error);
        } else {
          setIsloading(false);
          showErrorToast('Clone template creation failed. Pl try again');
        }
      } else {
        setIsloading(false);
        appData.setEdetailName(response.data.name);
        let pageId;
        if (
          response.data?.slides[0]?.slideid?._id === undefined ||
          response.data?.slides[0]?.slideid?._id === null
        ) {
          pageId = response.data.slides[0].slideid;
        } else {
          pageId = response.data.slides[0].slideid?._id;
        }
        if (localShared) {
          setDeckIdCurrent(response.data);
          setIsOpenSharedModal(true);
          setIsOpenCreateFromTemp(false);
        } else {
          navigateToEditor(pageId, response.data);
        }
        const cloneData = {
          edetailId: response.data._id,
          slides: [],
        };
        cloneData.slides.push({
          slideid: response.data.slides[0].slideid._id,
        });
        appData.setDeckId(response.data);
        // if (!localShared){
        showSuccessToast('e-Detail creation successful');
        // }
      }
    });
  };

  const onToggleProceedHandler = (selectedCardList) => {
    setIsOpenCreateFromTemp(false);
    setIsOpenSharedModal(true);
  };

  const handleExport = () => {
    if (exportFormats === "htmlveevaPackage") {
      let cardDataID = appData?.deckId?._id;

      setExportLoading(true);
      ExportDeckToMail(cardDataID, (response, err, errorCode) => {
        if (err) {
          showErrorToast('Export failed. Pl Try Again');

          setExportLoading(false);
          setOpenExportModal(false);
        } else {
          showSuccessToast(response.data || "Link will be emailed");
          setExportLoading(false);
          setOpenExportModal(false);
        }
      });

      setOpenExportModal(false);
      setExportFormats("");
    } else if (exportFormats === "mlrPdf") {
      PDFPreview(cardID, (response, err, errorCode) => {
        if (err) {
          console.log(err);
          showErrorToast('Export failed. Pl Try Again');
          setOpenExportModal(false);
        } else {
          showSuccessToast(response.data || "Link will be emailed");
          setOpenExportModal(false);
        }
      });
    }
  };

  //new implementation

  const fetchMore = (createdbyMe, skipRange, moreData, expired) => {
    setIsloading(true);

    if (searchClickEdetail) {
      // let marketID = marketDataList[market.indexOf(lastSearch?.market)];
      let searchPayload = {
        searchInput: lastSearch.searchInput,
        brand: lastSearch?.brand,
        device: lastSearch?.device?._id
          ? lastSearch?.device?._id
          : lastSearch?.device,
        campaign: lastSearch?.campaign,
        market: lastSearch?.market, //marketID === undefined ? "" : marketID._id,
        type: categoryType,
        skip: skipRange,
        limit: 100,
        created: createdbyMe,
        expired: expired,
      };
      searchForDetails(searchPayload, (response, err, errorCode) => {
        if (err) {
          setIsloading(false);
          showErrorToast('Unable to load right now. Please try again.'); // Failed to fetch
        } else {
          const data = response.data?.response?.decks;
          //chnages made for template to work
          // if (data.length < 100) {
          //   setHasMore(false);
          //   setIsloading(false);
          // }

          setCreatedbyMe(createdbyMe);
          let totalData = 0;
          if (moreData) {
            totalData = [...showFetchedResults, ...data];
          } else {
            totalData = [...data];
          }
          if (response.data.response?.totalCount[createdFlagKey[createdbyMe]] <= totalData.length) {
            setHasMore(false);
            setIsloading(false);
          } else if (response.data?.response?.totalCount[createdFlagKey[createdbyMe]] >= totalData.length) {
            setHasMore(true);
          }
          setshowFetchedResults(applyPendingUpdates(totalData));

          setShowCount(() => response.data?.response?.totalCount);
          setSkipRange(skipRange + limit);
          setIsloading(false);
        }
      });
    } else {
      //let createdbyMe = expired ? createdbyMe : true;
      getAlleDetail({
        eDetail,
        start: skipRange,
        limit,
        type: categoryType,
        created: createdbyMe,
        expired,
        callBack: async (response, err, errorCode) => {
          if (err) {
            setIsloading(false);
            showErrorToast('Unable to load right now. Please try again.'); // Failed to fetch
          } else {
            let result = await response;
            const data = result.data.response?.decks;

            let totalData = 0;
            if (moreData) {
              totalData = [...showFetchedResults, ...data];
              // console.log("scroll", moreData, showFetchedResults, data);
            } else {
              totalData = [...data];
            }
            if (response.data.response?.totalCount[createdFlagKey[createdbyMe]] <= totalData.length) {
              setHasMore(false);
              setIsloading(false);
            } else if (response.data.response?.totalCount[createdFlagKey[createdbyMe]] >= totalData.length) {
              setHasMore(true);
            }
            setshowFetchedResults(applyPendingUpdates(totalData));
            setCreatedbyMe(createdbyMe);
            setShowCount(() => result.data.response?.totalCount);
            setSkipRange(skipRange + limit);
            setIsloading(false);
          }
        },
      });
    }
  };

  const getUserDetail = () => {
    const data = window.localStorage.getItem("currentUserName");
    // const splitName = data.name.split(' ')
    // console.log(data, splitName)
    if (!data) return "";
    const nameArray = data.split(" ");
    const firstLetters = nameArray.map((name) => name.charAt(0));
    return firstLetters.join("");
    //splitName[0].charAt(0) + splitName[1].charAt(0)
  }
  // const getFirstLetters = () => {
  //   const userName = !!keycloak.authenticated
  //     ? keycloak.tokenParsed.name
  //     : null;
  //   if (!userName) return "";
  //   const nameArray = userName.split(" ");
  //   const firstLetters = nameArray.map((name) => name.charAt(0));
  //   return firstLetters.join("");
  // };
  const templateTour = () => {
    return (
      <>
        <p className="styled-paragraph-12">
          Create a new Template In 3 Simple Steps :
        </p>
        <span className="step-text">Step 1 :</span>
        <p className="styled-paragraph">Add Shared Resources, if required</p>
        <span className="step-text">Step 2 :</span>
        <p className="styled-paragraph-40">Author Template</p>
        <span className="step-text step3">Step 3 :</span>
        <p className="styled-paragraph-40">Publish</p>
      </>
    );
  };

  const edetailTour = () => {
    return (
      <>
        <p className="styled-paragraph-12">
          Create a new e-Detail In 4 Simple Steps :
        </p>
        <span className="step-text">Step 1 :</span>
        <p className="styled-paragraph-40">Import Modules</p>
        <span className="step-text step3">Step 2 :</span>
        <p className="styled-paragraph-40">Select Approved Template</p>
        <span className="step-text step3">Step 3 :</span>
        <p className="styled-paragraph-40">
          Author e-Detail
        </p>
        <span className="step-text step3">Step 4 :</span>
        <p className="styled-paragraph-40">Generate RSD & Publish</p>

      </>
    );
  }

  const unifiedRedirect = () => {
    window.location.href = unifiedPageUrl;
  }
  //end

  // const logoutMenu = React.forwardRef(
  //   ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
  //     return (
  //       <div
  //         ref={ref}
  //         style={style}
  //         className={`pt15 pb15 ${className}`}
  //         aria-labelledby={labeledBy}
  //       >
  //         <ul className="list-unstyled appDropdown">
  //           {React.Children.toArray(children).filter(
  //             (child) =>
  //               !value || child.props.children.toLowerCase().startsWith(value)
  //           )}
  //         </ul>
  //       </div>
  //     );
  //   }
  // );

  const getFirstLetters = () => {
    const userName = !!keycloak.authenticated
      ? keycloak.tokenParsed.name
      : null;
    if (!userName) return "";
    const nameArray = userName.split(" ");
    const firstLetters = nameArray.map((name) => name.charAt(0));
    return firstLetters.slice(0, 2).join("");
  };

  const getUserNameEmail = () => {
    const userName = !!keycloak.authenticated ? keycloak : null;
    return userName;
  };


  useEffect(() => {
    const handleAutoSync = (data) => {
      try {
        const parsedData = JSON.parse(data);
        const deckId = parsedData.deckId || parsedData.deckid;
        if (!deckId) return;

        const existing = pendingUpdates.current[deckId] ?? {};

        if (parsedData.type === "metadata_update" && parsedData.docStatus) {
          pendingUpdates.current[deckId] = {
            ...existing,
            metadata_update: { docStatus: parsedData.docStatus },
          };
          if(cardDetails) {
            setCardDetails((prevCardDetail)=>{
              const assetIndex = (prevCardDetail.veevaMetadata ?? []).findIndex(a => a.assetType === 1);
              let updatedItem = prevCardDetail;
              if (assetIndex !== -1) {
                const asset = prevCardDetail.veevaMetadata[assetIndex];
                if (asset.docStatus !== parsedData.docStatus) {
                  // clone item and metadata array only if changed
                  updatedItem = { ...updatedItem };
                  const newMetadata = [...(prevCardDetail.veevaMetadata ?? [])];
                  newMetadata[assetIndex] = { ...asset, docStatus: parsedData.docStatus };
                  updatedItem.veevaMetadata = newMetadata;
                }
              }
              return updatedItem;
            })
          }
        }

        if (parsedData.type === "export_status_update" && parsedData.status) {
          pendingUpdates.current[deckId] = {
            ...existing,
            export_status_update: {
              status: parsedData.status,
              fileUrl: parsedData.fileUrl,
              userId: parsedData.userId,
            },
          };
        }

        setshowFetchedResults(prev => {
          const index = prev.findIndex(i => i._id === deckId);
          if (index === -1) return prev;
          return applyPendingUpdates(prev);
        });
      } catch (error) {
        console.error("Error in handling autoSync:", error);
      }
    };


    emitter.on("autoSync", (data) => {
      handleAutoSync(data);
    });

    emitter.on("pdfToHtml", (data) => {
      if(data.status){
        showSuccessToast(data.message)
        getEdetailList(categoryType, "me")
      }else{
        showErrorToast(data.message)
      }
    })
    
  }, [cardDetails]);

  const isPdfToHtml = cardDetails?.tags.includes('PDF_TO_HTML');

  return (
    <>
      {exportLoading && (
        <CircularProgressBar
          isloading={exportLoading}
          setIsloading={setExportLoading}
        />
      )}
      <div className="container-fluid bg-transparent containerWrapper">
        <div className="tempMng">
          {/* Header part for gilead ui */}
          <div className="header-dashoboard">
            <div className="left-side-icons">
              <img src={nineDotIcon} onClick={unifiedRedirect} />
              <img src={gileadIcon} />
            </div>
            <div className="right-side">
              {/* <div className="promomats-text-container">
                <div className="source-text">Source</div>
                <div className="promo-text">PromoMats</div>
              </div> */}
              {/*  <div className="noti-icon-class1">
                <img className="notification-icon1" src={notifyBell} />
              </div> */}
              <div>
                <div className="logOutButton dropdown">
                  <div>
                    <Dropdown onToggle={isOpen => setExpanded(isOpen)} className="logOutButton">
                      <Dropdown.Toggle as={logoutButton} expanded={expanded} drop="left" id="logoutButton" />
                      <Dropdown.Menu>
                        <LogoutDropdownCard
                          getFirstLetters={getFirstLetters}
                          getUserNameEmail={getUserNameEmail()}
                        />
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* switch selection for template/edetail gilead */}
          <div className="switch-to-board">
            <div className="manager-borad">
              <div className="manger-name">
                {`${categoryType === 2 ? "e-Detail" : "Template"}`} Manager
              </div>
              <div className="manger-desc">
                Create & Browse{" "}
                {`${categoryType === 2 ? "e-Details" : "Templates"}`}
              </div>
            </div>
            <div className="manager-icon">
              <div style={{ textAlign: 'end' }}>
                {categoryType === 2 && <img src={activeManagerTip} style={{ position: 'relative', left: '82px', top: '43px' }} />}
                <img
                  className={`${categoryType === 2 ? "activeImgCss" : "notActiveImg"}`}
                  src={categoryType === 2 ? edetailActive : edetailInactive}
                  onClick={() => { 
                    handleTabClick("edetail");
                  }}
                />

              </div>
              <div><img
                className={`${categoryType === 1 ? "activeTemplate" : "notActiveImg"}`}
                src={categoryType === 1 ? templateActive : templateInactive}
                onClick={() => {                  
                  handleTabClick("template");
                }}
              />
                {categoryType === 1 && <img src={activeManagerTip} style={{ position: 'relative', right: '82px', top: '43px' }} />}
              </div>
            </div>
            <div className="manager-right"></div>
          </div>
          {/* end switch selection for template/edetail gilead  */}
          {/* searchManager with new UI */}
          {/*<div className="search-manager-container-board">
            <SearchManagerComponent  
              brands={brands}  
              market={market}
              showCount={showCount}
              createPresentationFields={createPresentationFields}
              setCreatePresentationFields={setCreatePresentationFields}
              type={createPresentationFields.type}
              refreshComp={refreshComp}
            >
            </SearchManagerComponent> 
          </div>*/}
          {/* end  searchManager with new UI */}
          <div className="d-flex">
            {/* <div className="tempMngLeftPanel">
              <TemplateHeader />
              <TemplateLeftPanel
                createTemplate={createTemplate}
                setCreateEdetail={setCreateEdetail}
                createEdetail={createEdetail}
                setCreateTemplate={setCreateTemplate}
                handleCreatebutton={handleCreatebutton}
              />
            </div> */}
            <div className="tempMngRightPanel flex-grow-1">
              {isloading && (
                <CircularProgressBar
                  isloading={isloading}
                  setIsloading={setIsloading}
                />
              )}
              {createEdetail ? (
                <EDetailForm
                  // searchClick={searchClick}
                  // setSearchClick={setSearchClick}
                  marketDataList={marketDataList}
                  textFieldValidationError={textFieldValidationError}
                  searchClickEdetail={searchClickEdetail}
                  setSearchClickEdetail={setSearchClickEdetail}
                  openCreateNewPresenationModal={openCreateNewPresenationModal}
                  createNewEdetail={createNewEdetail}
                  openCreateNewtemplate={openCreateNewtemplate}
                  setOpenCreateNewtemplate={setOpenCreateNewtemplate}
                  isloading={isloading}
                  setIsloading={setIsloading}
                  createEdetail={createEdetail}
                  createTemplate={createTemplate}
                  createPresentationFields={createPresentationFields}
                  setCreatePresentationFields={setCreatePresentationFields}
                  edetailList={edetailList}
                  setEDetailFields={setEDetailFields}
                  eDetailFields={eDetailFields}
                  sendSearchDataToEdetails={sendSearchDataToEdetails}
                  deleteEdetailCard={deleteEdetailCard}
                  createFromTemplate={createFromTemplate}
                  isOpenCreateFromTemp={isOpenCreateFromTemp}
                  setIsOpenCreateFromTemp={setIsOpenCreateFromTemp}
                  fetchBrands={fetchBrands}
                  type={eDetail}
                  brands={brands}
                  market={market}
                  campaign={campaign}
                  handleDeletetemplate={handleDeletetemplate}
                  setEdetailList={setEdetailList}
                  categoryType={categoryType}
                  // setCategoryType={setCategoryType}
                  setShowHeading={setShowHeading}
                  showHeading={showHeading}
                  // showResults={showResults}
                  searchresults={edetailList?.length}
                  onProceedHandler={onProceedHandler}
                  totalCount={totalCount}
                  clicKRsdPreview={clicKRsdPreview}
                  handleExportModal={handleExportModal}
                  closeExportModal={closeExportModal}
                  openExportModal={openExportModal}
                  handleExport={handleExport}
                  fetchMore={fetchMore}
                  showCount={showCount}
                  setshowFetchedResults={setshowFetchedResults}
                  setShowCount={setShowCount}
                  setCreatedbyMe={setCreatedbyMe}
                  setHasMore={setHasMore}
                  createdbyMe={createdbyMe}
                  skipRange={skipRange}
                  hasMore={hasMore}
                  showFetchedResults={showFetchedResults}
                  setCreatedbyOthers={setCreatedbyOthers}
                  createdByOthers={createdByOthers}
                  lastSearch={lastSearch}
                  setLastSearch={setLastSearch}
                  infinteScrollRef={infinteScrollRef}
                  cardDetailsHandler={cardDetailsHandler}
                  cardDetails={cardDetails}
                  setExpired={setExpired}
                  expired={expired}
                  expireTemplateHandler={expireTemplateHandler}
                  sharedToggle={sharedToggle}
                  setSharedToggle={setSharedToggle}
                  // openShardedHandler={openShardedHandler}
                  isOpenSharedModal={isOpenSharedModal}
                  setIsOpenSharedModal={setIsOpenSharedModal}
                  onToggleProceedHandler={onToggleProceedHandler}
                  deckIdCurrent={deckIdCurrent}
                  setLocalShared={setLocalShared}
                  localShared={localShared}
                  cameFrom={cameFrom}
                  setDeckIdCurrent={setDeckIdCurrent}
                  fetchingList={fetchingList}
                  fetchingListError={fetchingListError}
                />
              ) : (
                <Template
                  marketDataList={marketDataList}
                  textFieldValidationError={textFieldValidationError}
                  searchresults={edetailList.length}
                  setShowHeading={setShowHeading}
                  showHeading={showHeading}
                  setSearchClickEdetail={setSearchClickEdetail}
                  openCreateNewPresenationModal={openCreateNewPresenationModal}
                  createNewEdetail={createNewEdetail}
                  openCreateNewtemplate={openCreateNewtemplate}
                  setOpenCreateNewtemplate={setOpenCreateNewtemplate}
                  isloading={isloading}
                  setIsloading={setIsloading}
                  createEdetail={createEdetail}
                  createTemplate={createTemplate}
                  createPresentationFields={createPresentationFields}
                  setCreatePresentationFields={setCreatePresentationFields}
                  edetailList={edetailList}
                  setEDetailFields={setEDetailFields}
                  eDetailFields={eDetailFields}
                  sendSearchDataToEdetails={sendSearchDataToEdetails}
                  openCloneTemplate={openCloneTemplate}
                  setOpenCloneTemplate={setOpenCloneTemplate}
                  openCloneTemplateModal={openCloneTemplateModal}
                  closeCloneTemplateModal={closeCloneTemplateModal}
                  cloneTempdata={cloneTempdata}
                  setCloneTempdata={setCloneTempdata}
                  getEdetailList={getEdetailList}
                  fetchBrands={fetchBrands}
                  type={template}
                  brands={brands}
                  market={market}
                  campaign={campaign}
                  handleDeletetemplate={handleDeletetemplate}
                  setEdetailList={setEdetailList}
                  categoryType={categoryType}
                  // setCategoryType={setCategoryType}
                  // showTemplateRes={showTemplateRes}
                  clicKRsdPreview={clicKRsdPreview}
                  handleExportModal={handleExportModal}
                  closeExportModal={closeExportModal}
                  openExportModal={openExportModal}
                  handleExport={handleExport}
                  totalCount={totalCount}
                  exportFormats={exportFormats}
                  setExportFormats={setExportFormats}
                  showFetchedResults={showFetchedResults}
                  skipRange={skipRange}
                  hasMore={hasMore}
                  fetchMore={fetchMore}
                  lastSearch={lastSearch}
                  setLastSearch={setLastSearch}
                  infinteScrollRef={infinteScrollRef}
                  lockTemplate={lockTemplate}
                  showCount={showCount}
                  createdbyMe={createdbyMe}
                  setCreatedbyMe={setCreatedbyMe}
                  setshowFetchedResults={setshowFetchedResults}
                  cardDetailsHandler={cardDetailsHandler}
                  setExpired={setExpired}
                  expired={expired}
                  expireTemplateHandler={expireTemplateHandler}
                  sharedToggle={sharedToggle}
                  setSharedToggle={setSharedToggle}
                  // openShardedHandler={openShardedHandler}
                  isOpenSharedModal={isOpenSharedModal}
                  setIsOpenSharedModal={setIsOpenSharedModal}
                  onToggleProceedHandler={onToggleProceedHandler}
                  appData={appData}
                  setLocalShared={setLocalShared}
                  localShared={localShared}
                  setDeckIdCurrent={setDeckIdCurrent}
                  searchClickEdetail={searchClickEdetail}
                  cameFrom={cameFrom}
                  fetchingList={fetchingList}
                  fetchingListError={fetchingListError}
                />
              )}
              {/* Search results Ends */}
            </div>
          </div>{" "}
        </div>
      </div>
      {openDeleteTempModal && (
        <DeleteTemplate
          deleteEdetailCard={deleteEdetailCard}
          openDeleteTempModal={openDeleteTempModal}
          handleDeletetemplate={handleDeletetemplate}
          closeDeletetemplate={closeDeletetemplate}
          deleteId={deleteId}
        />
      )}
      {openExportModal && (
        <CustomModal
          displayModal={openExportModal}
          hideModal={() => {
            closeExportModal();
          }}
          title={""}
          size="sm"
          dilogClassName="alertModalSmall"
          keyboard={false}
          openExportModal={openExportModal}
        >
          <ExportTemplate
            closeExportModal={closeExportModal}
            openExportModal={openExportModal}
            // cardData={showTemplateRes}
            exportFormats={exportFormats}
            setExportFormats={setExportFormats}
            handleExport={handleExport}
          />
        </CustomModal>
      )}
      {openLockModal && (
        <CustomModal
          displayModal={openLockModal}
          hideModal={() => {
            closeLockModal();
          }}
          title={""}
          size="sm"
          // style={{height: "200px !important"}}
          dilogClassName="lock-template-modal"
          keyboard={false}
        // openExportModal={openExportModal}
        >
          <LockTemplate
            closeLockModal={closeLockModal}
            proceedLock={proceedLock}
            lockCardData={lockCardData}
          />
        </CustomModal>
      )}
      {openCardDetailsModal && (
        <CustomModal
          displayModal={openCardDetailsModal}
          hideModal={() => {
            closeCardDetailsModal();
          }}
          title={""}
          size="lg"
          // style={{height: "577px !important"}}
          dilogClassName="detail-informations-modal"
          keyboard={false}
        // openCardDetailsModal={openCardDetailsModal}
        >
          {!isPdfToHtml ? <DetailsInformationsModal
            mode="edit"
            // setOpenCardDetailsModal={setOpenCardDetailsModal}
            closeCardDetailsModal={closeCardDetailsModal}
            cardInformation={cardDetails}
            templateType={templateType}
            detailLink={defaultLink}
            brands={brands}
            countriesList={marketDetails}
            deckId={cardDetails?._id}
            setCardInformation={setCardDetails}
            setshowFetchedResults={setshowFetchedResults}
            linkForCardView = "cardView"
          />  : <PdfDetailsInformationModal
            mode="details"
            // setOpenCardDetailsModal={setOpenCardDetailsModal}
            closeCardDetailsModal={closeCardDetailsModal}
            cardInformation={cardDetails}
            templateType={templateType}
            detailLink={defaultLink}
            brands={brands}
            countriesList={marketDetails}
            
          />}
        </CustomModal>
      )}

      {openExpireModal && (
        <CustomModal
          displayModal={openExpireModal}
          hideModal={() => {
            closeExpireTemplateModal();
          }}
          title={""}
          size="lg"
          dilogClassName="expire-template-modal"
          keyboard={false}
        >
          <ExpireTemplate
            closeExpireTemplateModal={closeExpireTemplateModal}
            expireTemplateData={expireTemplateData}
            expireProceedHandler={expireProceedHandler}
            templateTypes={templateTypes}
          />
        </CustomModal>
      )}
      {localShared && ( //
        <SharedResource
          setOpenSharedResource={setIsOpenSharedModal} //
          deckIdCurrent={deckIdCurrent}
          isOpenSharedModal={isOpenSharedModal} //
          modeFrom={tempValue === 1 ? "Template" : ""}
        />
      )}
      <div className="tour-cards-container">
        <TourPage
          banner={showFetchedResults}
          //setSelectedtab={setSelectedtab}
          setIsOpen={setIsOpen}
          isOpen={isOpen}
          eDetail={eDetail}
          type={categoryType === eDetail ? 2 : 1}
        >
          {categoryType === eDetail ? edetailTour() : templateTour()}
        </TourPage>
      </div>
    </>
  );
};

export default EDetails;
